module.exports = __webpack_public_path__ + "fonts/gill-sans.afd00038.otf";